import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ROUTE_PATHS } from '@/config/routes'
import { YARDI_RESIDENT_MATCHING_CRON_ID } from '@/features/yardi-matching/constants'
import { getCronJobs } from '@/features/jobs/services/jobsService'
import { formatCronSchedule } from '@/features/jobs/utils/cronFormatters'
import type { CronJob } from '@/features/jobs/types'

export const PROPERTY_MAPPING_CRON_EDIT_PATH = `${ROUTE_PATHS.DASHBOARD_JOBS_CRON}?edit=${encodeURIComponent(YARDI_RESIDENT_MATCHING_CRON_ID)}`

export function PmsAutomationFrequency({
  label = 'Property Mapping',
}: {
  label?: string
}) {
  const [job, setJob] = useState<CronJob | null>(null)

  useEffect(() => {
    void getCronJobs({ q: YARDI_RESIDENT_MATCHING_CRON_ID })
      .then((rows) => {
        const match = rows.find(
          (row) => String(row.cron_id).toUpperCase() === YARDI_RESIDENT_MATCHING_CRON_ID,
        )
        setJob(match || null)
      })
      .catch(() => setJob(null))
  }, [])

  const schedule = job ? formatCronSchedule(job) : 'Not configured'
  const nextRun = job?.next_run_at
    ? new Date(job.next_run_at).toLocaleString('en-US', {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : null

  return (
    <p className="mt-2 text-sm text-slate-600" data-testid="pms-automation-frequency">
      {label} automation frequency: <span className="font-semibold text-slate-800">{schedule}</span>
      {nextRun ? <span>{` · Next run ${nextRun} UTC`}</span> : null}
      {'. '}
      <Link
        to={PROPERTY_MAPPING_CRON_EDIT_PATH}
        className="font-semibold text-sky-600 hover:underline"
        data-testid="pms-automation-frequency-cron-link"
      >
        Click here
      </Link>{' '}
      to configure the schedule.
    </p>
  )
}
